<template>
  <md-dialog :md-active.sync="dialogVisible" class="insert-dialog">
    <md-dialog-title class="dialog-title">
      <md-icon class="title-icon">fingerprint</md-icon>
      ادراج بصمة
    </md-dialog-title>
    <md-dialog-content class="dialog-content">
      <md-toolbar v-if="errorMessage" class="md-danger">
        <h3 class="md-title">{{ errorMessage }}</h3>
      </md-toolbar>
      <div class="content-container">
        <div class="selection-section">
          <div class="md-layout">
            <div class="md-layout-item">
              <form>
                <md-card class="p-25">
                  <md-card-content>
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100">
                        <label>الموظف</label>
                        <model-list-select
                          class="input-must-rtl"
                          :list="employeesList"
                          v-model="employeeId"
                          option-value="key"
                          option-text="value"
                          @input="clearInput"
                        />
                      </div>

                      <div class="md-layout-item md-size-100 mt-25">
                        <md-datepicker :md-open-on-focus="false" v-model="day">
                          <label class="mr-28">اليوم</label>
                        </md-datepicker>
                      </div>

                      <div class="md-layout-item md-size-100">
                        <form-time
                          v-model="time"
                          class="form-date"
                          placeholder="وقت البصمة"
                          label
                        />
                      </div>

                      <div class="md-layout-item md-size-100 mt-25">
                        <md-field>
                          <label>نوع البصمة</label>

                          <md-select v-model="signType">
                            <md-option :value="1">دخول</md-option>
                            <md-option :value="2">خروج</md-option>
                          </md-select>
                        </md-field>
                      </div>
                      <div class="md-layout-item md-size-100 mt-25">
                        <label>أماكن العمل</label>
                        <model-list-select
                          class="input-must-rtl"
                          :list="workPlaces"
                          v-model="workplaceId"
                          option-value="id"
                          option-text="name"
                          @input="clearInput"
                        />
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </form>
            </div>
          </div>
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions class="dialog-actions">
      <div class="action-buttons">
        <md-button
          class="md-accent cancel-btn ml-25"
          @click="closeChangeTypeDialog"
        >
          <md-icon class="btn-icon">close</md-icon>
          <span class="btn-text">إلغاء</span>
        </md-button>

        <md-button
          class="md-primary"
          @click="confirmChange"
          :disabled="insertLoading"
        >
          <md-progress-spinner
            v-if="insertLoading"
            class="md-accent"
            :md-diameter="15"
            :md-stroke="2"
            md-mode="indeterminate"
          />
          <md-icon v-else class="btn-icon">check</md-icon>
          <span class="ml-15"> تأكيد </span>
        </md-button>
        <!-- <md-button
          class="md-primary confirm-btn ml-25"
          @click="confirmChange"
          :disabled="insertLoading"
        >
          <md-icon class="btn-icon">check</md-icon>
          <span class="btn-text">تأكيد</span>
        </md-button> -->
      </div>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
export default {
  components: {
    ModelListSelect,
  },
  props: {
    parentEmployeeId: {
      type: String,
      default: null,
    },
    showInsertLogDialog: {
      type: Boolean,
      default: false,
    },
    workPlaces: {
      type: Array,
      default: () => [],
    },
    insertLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.showInsertLogDialog;
      },
      set(value) {
        this.$emit("update:showInsertLogDialog", value);
      },
    },
    employeesList() {
      const lists = this.$store.getters["global/employeesData"];
      return lists?.employees || [];
    },
  },
  watch: {
    showInsertLogDialog(newValue, oldValue) {
      this.employeeId = this.parentEmployeeId;
      if (!newValue) {
        this.employeeId = null;
        this.day = null;
        this.time = null;
        this.signType = 1;
        this.workplaceId = null;
        this.errorMessage = null;
      }
    },
  },

  data() {
    return {
      employeeId: null,
      day: null,
      time: null,
      signType: 1,
      workplaceId: null,
      errorMessage: null,
    };
  },
  methods: {
    closeChangeTypeDialog() {
      this.$emit("close-dialog");
      this.$emit("update:showInsertLogDialog", false);
    },
    confirmChange() {
      let valid = true;

      if (!this.time) {
        this.errorMessage = "يرجى اختيار الوقت";
        valid = false;
      }
      if (!this.day) {
        this.errorMessage = "يرجى اختيار اليوم";
        valid = false;
      }

      if (!this.employeeId) {
        this.errorMessage = "يرجى اختيار الموظف";
        valid = false;
      }

      setTimeout(() => {
        this.errorMessage = null;
      }, 3000);

      if (!valid) {
        return;
      }
      // إرسال البيانات المحدثة للمكون الأب
      this.$emit("confirm-change", {
        employeeId: this.employeeId,
        day: this.day,
        time: this.time,
        signType: this.signType,
        workplaceId: this.workplaceId ? this.workplaceId : null,
      });
      // this.closeChangeTypeDialog();
    },
    clearInput() {},
  },
};
</script>

<style lang="scss">
/* Dialog Styles */
.insert-dialog {
  direction: rtl;
  align-items: flex-start;
  top: 20px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;

  .md-dialog-container {
    width: 90%;
    max-width: 800px;
    min-height: auto;
    max-height: calc(100vh - 40px);
    margin: 0 auto;
    overflow-y: auto;

    @media (max-width: 768px) {
      width: 95%;
      margin: 0;
      top: 10px;
    }

    @media (max-width: 480px) {
      width: 98%;
      top: 5px;
    }
  }
  .dialog-title {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;

    .title-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }

  .dialog-content {
    padding: 30px 24px;
    background: #fafafa;
    max-height: calc(100vh - 200px);
    overflow-y: auto;

    @media (max-width: 768px) {
      padding: 20px 16px;
      max-height: calc(100vh - 150px);
    }

    @media (max-width: 480px) {
      padding: 15px 12px;
      max-height: calc(100vh - 120px);
    }
  }

  .content-container {
    max-width: 100%;
  }

  .divider {
    height: 2px;
    background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
    margin: 20px 0;
  }
}

.dialog-actions {
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  background: white;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }

  @media (max-width: 480px) {
    padding: 10px 12px;
  }
}

.action-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;

  @media (max-width: 480px) {
    gap: 10px;
    flex-direction: column;
  }
}
</style>
